import axios from 'axios';
import authHeader from "../../services/auth-header";
import ConstApiUrls from "../../services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL

class FVendorService {
    getApiUrl() {
        return API_URL
    }

    getAllFVendor(){
        return axios.get(API_URL + `getAllFVendor`, { headers: authHeader() });
    }
    getAllFVendorByCompany(){
        return axios.get(API_URL + `getAllFVendorByCompany`, { headers: authHeader() });
    }
    getAllFVendorContaining(page, pageSize, sortBy, order, search){
        // return axios.get(API_URL + `getAllFVendor`, { headers: authHeaderMultipart() });
        return axios.get(API_URL + `getAllFVendorContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`, { headers: authHeader() });
    }
    getFVendorById(id){
        return axios.get(API_URL + `getFVendorById/${id}`, { headers: authHeader() });
    }
    updateFVendor(item){
        return axios.put(API_URL + `updateFVendor/${item.id}`, item, {headers: authHeader()})
    }
    createFVendor(item){
        return axios.post(API_URL + `createFVendor`, item, {headers: authHeader()})
    }
    deleteFVendor(id){
        return axios.delete(API_URL + `deleteFVendor/${id}`, {
            headers: authHeader()
        });
    }
    deleteAllFVendor(itemIds){
        // let user = JSON.parse(localStorage.getItem('user'));
        // return axios.delete(API_URL + `deleteAllFVendor`, {
        //     headers:  authHeaderMultipart(),
        //     data: {
        //         message: 'delete  success'
        //     }
        // });
        return axios.delete(API_URL + `deleteAllFVendor`, {
            headers:  authHeader(),
            data: itemIds
        });


    }
}
export default new FVendorService()